const textFieldFormCompany = {
  name: 'Razón social',
  tradingName: 'Nombre comercial',
  cnpj: 'CNPJ',
  email: 'E-mail',
  accountable: 'Responsable',
  phone: 'Números de contacto',

};

export default textFieldFormCompany;
